import { render } from "./ChartOfAccount.vue?vue&type=template&id=63f11de3&scoped=true"
import script from "./ChartOfAccount.vue?vue&type=script&lang=js"
export * from "./ChartOfAccount.vue?vue&type=script&lang=js"

import "./ChartOfAccount.vue?vue&type=style&index=0&id=63f11de3&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f11de3"]])

export default __exports__